// import React, { useState, useEffect } from 'react';
// import { Eye, EyeOff, Mail, Lock, Loader2, Building2, User, Phone, Globe, Link, ChevronDown } from 'lucide-react';
// import { useGoogleLogin } from '@react-oauth/google';
// import axios from 'axios';
// import { toast } from 'react-toastify';
// import { useNavigate } from 'react-router-dom';
// import Logo from "../assets/images/Logo.png";

// // Timezone data (simplified - you can expand this)
// const timezones = [
//   { value: 'UTC', label: '(UTC+00:00) UTC' },
//   { value: 'America/New_York', label: '(UTC-05:00) Eastern Time (US & Canada)' },
//   { value: 'America/Chicago', label: '(UTC-06:00) Central Time (US & Canada)' },
//   { value: 'America/Denver', label: '(UTC-07:00) Mountain Time (US & Canada)' },
//   { value: 'America/Los_Angeles', label: '(UTC-08:00) Pacific Time (US & Canada)' },
//   { value: 'Europe/London', label: '(UTC+00:00) London' },
//   { value: 'Europe/Paris', label: '(UTC+01:00) Paris, Berlin' },
//   { value: 'Asia/Dubai', label: '(UTC+04:00) Dubai' },
//   { value: 'Asia/Kolkata', label: '(UTC+05:30) India Standard Time' },
//   { value: 'Asia/Shanghai', label: '(UTC+08:00) Beijing, Shanghai' },
//   { value: 'Asia/Tokyo', label: '(UTC+09:00) Tokyo' },
//   { value: 'Australia/Sydney', label: '(UTC+10:00) Sydney' },
// ];

// // Countries list (simplified)
// const countries = [
//   'United States', 'United Kingdom', 'Canada', 'Australia', 'India', 
//   'Germany', 'France', 'Spain', 'Italy', 'Brazil', 'Mexico', 
//   'Japan', 'China', 'Singapore', 'UAE', 'South Africa'
// ];

// // Industries
// const industries = [
//   'Technology', 'Healthcare', 'Finance', 'Education', 'Retail',
//   'Manufacturing', 'Real Estate', 'Hospitality', 'Media & Entertainment',
//   'Transportation', 'Non-Profit', 'Government', 'Other'
// ];

// // Company sizes
// const companySizes = [
//   '1-10 employees',
//   '11-50 employees',
//   '51-200 employees',
//   '201-500 employees',
//   '501-1000 employees',
//   '1000+ employees'
// ];

// const SignUp = () => {
//   const [currentStep, setCurrentStep] = useState(1);
//   const [formData, setFormData] = useState({
//     // Personal Information
//     firstName: '',
//     lastName: '',
//     email: '',
//     phone: '',
//     password: '',
//     confirmPassword: '',

//     // Organization Information
//     organizationName: '',
//     portalName: '',
//     industry: '',
//     companySize: '',

//     // Location & Settings
//     country: '',
//     timezone: '',
//     language: 'English',
//     currency: 'USD',

//     // Agreement
//     termsAccepted: false,
//     marketingEmails: false
//   });

//   const [errors, setErrors] = useState({});
//   const [showPassword, setShowPassword] = useState(false);
//   const [showConfirmPassword, setShowConfirmPassword] = useState(false);
//   const [isLoading, setIsLoading] = useState(false);
//   const [portalAvailable, setPortalAvailable] = useState(null);
//   const [checkingPortal, setCheckingPortal] = useState(false);
//   const navigate = useNavigate();

//   // Auto-generate portal name from organization name
//   useEffect(() => {
//     if (formData.organizationName && !formData.portalName) {
//       const portalName = formData.organizationName
//         .toLowerCase()
//         .replace(/[^a-z0-9]/g, '')
//         .substring(0, 20);
//       setFormData(prev => ({ ...prev, portalName }));
//     }
//   }, [formData.organizationName]);

//   // Check portal availability (debounced)
//   useEffect(() => {
//     const timer = setTimeout(() => {
//       if (formData.portalName && formData.portalName.length > 3) {
//         checkPortalAvailability();
//       }
//     }, 500);

//     return () => clearTimeout(timer);
//   }, [formData.portalName]);

//   const checkPortalAvailability = async () => {
//     setCheckingPortal(true);
//     try {
//       const response = await axios.get(`http://localhost:8080/api/check-portal/${formData.portalName}`);
//       setPortalAvailable(response.data.available);
//     } catch (error) {
//       console.error('Error checking portal availability:', error);
//     } finally {
//       setCheckingPortal(false);
//     }
//   };

//   // Validate email format
//   const validateEmail = (email) => {
//     const emailRegex = /^[^\s@]+@[^\s@]+\.[^\s@]+$/;
//     return emailRegex.test(email);
//   };

//   // Validate form based on current step
//   const validateStep = () => {
//     const newErrors = {};

//     if (currentStep === 1) {
//       // Personal Information validation
//       if (!formData.firstName.trim()) newErrors.firstName = 'First name is required';
//       if (!formData.lastName.trim()) newErrors.lastName = 'Last name is required';
//       if (!formData.email.trim()) {
//         newErrors.email = 'Email is required';
//       } else if (!validateEmail(formData.email)) {
//         newErrors.email = 'Please enter a valid email address';
//       }
//       if (!formData.phone.trim()) newErrors.phone = 'Phone number is required';
//       if (!formData.password) {
//         newErrors.password = 'Password is required';
//       } else if (formData.password.length < 8) {
//         newErrors.password = 'Password must be at least 8 characters';
//       } else if (!/(?=.*[a-z])(?=.*[A-Z])(?=.*\d)/.test(formData.password)) {
//         newErrors.password = 'Password must contain uppercase, lowercase and numbers';
//       }
//       if (formData.password !== formData.confirmPassword) {
//         newErrors.confirmPassword = 'Passwords do not match';
//       }
//     } else if (currentStep === 2) {
//       // Organization Information validation
//       if (!formData.organizationName.trim()) newErrors.organizationName = 'Organization name is required';
//       if (!formData.portalName.trim()) {
//         newErrors.portalName = 'Portal name is required';
//       } else if (portalAvailable === false) {
//         newErrors.portalName = 'This portal name is already taken';
//       }
//       if (!formData.industry) newErrors.industry = 'Please select an industry';
//       if (!formData.companySize) newErrors.companySize = 'Please select company size';
//     } else if (currentStep === 3) {
//       // Location & Settings validation
//       if (!formData.country) newErrors.country = 'Please select a country';
//       if (!formData.timezone) newErrors.timezone = 'Please select a timezone';
//       if (!formData.termsAccepted) newErrors.termsAccepted = 'You must accept the terms and conditions';
//     }

//     setErrors(newErrors);
//     return Object.keys(newErrors).length === 0;
//   };

//   // Handle input changes
//   const handleInputChange = (e) => {
//     const { name, value, type, checked } = e.target;
//     setFormData(prev => ({
//       ...prev,
//       [name]: type === 'checkbox' ? checked : value
//     }));

//     // Clear error for the field being edited
//     if (errors[name]) {
//       setErrors(prev => ({
//         ...prev,
//         [name]: ''
//       }));
//     }
//   };

//   // Handle next step
//   const handleNextStep = () => {
//     if (validateStep()) {
//       setCurrentStep(prev => prev + 1);
//     }
//   };

//   // Handle previous step
//   const handlePrevStep = () => {
//     setCurrentStep(prev => prev - 1);
//   };

//   // Handle form submission
//   const handleSubmit = async (e) => {
//     e.preventDefault();

//     if (!validateStep()) {
//       return;
//     }

//     setIsLoading(true);

//     try {
//       const { data } = await axios.post('http://localhost:8080/api/signup', formData);

//       localStorage.setItem('token', data.token);
//       localStorage.setItem('user', JSON.stringify(data.user));
//       toast.success('Account created successfully!');

//       navigate('/onboarding'); // Navigate to onboarding flow

//     } catch (error) {
//       if (error.response?.data?.message) {
//         toast.error(error.response.data.message);
//       } else {
//         toast.error('Signup failed. Please try again.');
//       }
//     } finally {
//       setIsLoading(false);
//     }
//   };

//   // Google Signup
//   const googleSignup = useGoogleLogin({
//     onSuccess: async (tokenResponse) => {
//       try {
//         const { access_token } = tokenResponse;
//         const { data } = await axios.post('http://localhost:8080/api/google-signup', {
//           token: access_token,
//         });

//         // Pre-fill form with Google data
//         setFormData(prev => ({
//           ...prev,
//           email: data.email,
//           firstName: data.given_name || '',
//           lastName: data.family_name || ''
//         }));

//         toast.info('Please complete your organization details');
//         setCurrentStep(2);

//       } catch (error) {
//         toast.error('Google signup failed.');
//       }
//     },
//     onError: () => {
//       toast.error('Google signup error');
//     }
//   });

//   return (
//     <div className="min-h-screen relative overflow-hidden bg-gradient-to-br from-blue-50 via-green-50 to-yellow-50">
//       {/* Background Pattern */}
//       <div className="absolute inset-0 opacity-10">
//         <div 
//           className="absolute inset-0" 
//           style={{
//             backgroundImage: `
//               repeating-linear-gradient(45deg, transparent, transparent 35px, rgba(59, 130, 246, 0.1) 35px, rgba(59, 130, 246, 0.1) 70px),
//               repeating-linear-gradient(-45deg, transparent, transparent 35px, rgba(239, 68, 68, 0.1) 35px, rgba(239, 68, 68, 0.1) 70px),
//               repeating-linear-gradient(90deg, transparent, transparent 50px, rgba(34, 197, 94, 0.1) 50px, rgba(34, 197, 94, 0.1) 100px)
//             `
//           }}
//         />
//         <div className="absolute top-20 left-20 w-24 h-24 bg-blue-500 opacity-10 rounded-lg transform rotate-45"></div>
//         <div className="absolute top-40 right-40 w-32 h-32 bg-red-500 opacity-10 rounded-lg transform rotate-12"></div>
//         <div className="absolute bottom-20 left-1/3 w-28 h-28 bg-green-500 opacity-10 rounded-lg transform -rotate-12"></div>
//         <div className="absolute bottom-40 right-20 w-20 h-20 bg-yellow-500 opacity-10 rounded-lg transform rotate-45"></div>
//       </div>

//       <div className="relative flex items-center justify-center min-h-screen p-4">
//         <div className="bg-white rounded-2xl shadow-2xl w-full max-w-2xl p-8 backdrop-blur-sm my-8">
//           {/* Header */}
//           <div className="text-center mb-6">
//             <div className="flex justify-center mb-4">
//               <img src={Logo} alt="Cuso Business Logo" className="w-12 h-12"/>
//             </div>
//             <h1 className="text-3xl font-bold text-gray-900 mb-2">Create your account</h1>
//             <p className="text-gray-600">Start your 14-day free trial</p>

//             {/* Progress Steps */}
//             <div className="mt-6 flex items-center justify-center space-x-2">
//               {[1, 2, 3].map((step) => (
//                 <React.Fragment key={step}>
//                   <div className={`
//                     w-8 h-8 rounded-full flex items-center justify-center text-sm font-medium
//                     ${currentStep >= step 
//                       ? 'bg-blue-600 text-white' 
//                       : 'bg-gray-200 text-gray-500'}
//                   `}>
//                     {step}
//                   </div>
//                   {step < 3 && (
//                     <div className={`w-16 h-1 ${currentStep > step ? 'bg-blue-600' : 'bg-gray-200'}`} />
//                   )}
//                 </React.Fragment>
//               ))}
//             </div>
//             <div className="mt-2 text-sm text-gray-600">
//               {currentStep === 1 && "Personal Information"}
//               {currentStep === 2 && "Organization Details"}
//               {currentStep === 3 && "Settings & Confirmation"}
//             </div>
//           </div>

//           {/* Form */}
//           <form onSubmit={handleSubmit}>
//             {/* Step 1: Personal Information */}
//             {currentStep === 1 && (
//               <div className="space-y-4">
//                 <div className="grid grid-cols-2 gap-4">
//                   <div>
//                     <label className="block text-sm font-medium text-gray-700 mb-2">First Name</label>
//                     <div className="relative">
//                       <div className="absolute inset-y-0 left-0 pl-3 flex items-center pointer-events-none">
//                         <User className="h-5 w-5 text-gray-400" />
//                       </div>
//                       <input
//                         type="text"
//                         name="firstName"
//                         value={formData.firstName}
//                         onChange={handleInputChange}
//                         className={`
//                           w-full pl-10 pr-3 py-3 border rounded-lg
//                           ${errors.firstName ? 'border-red-300' : 'border-gray-300'}
//                         `}
//                         placeholder="John"
//                       />
//                     </div>
//                     {errors.firstName && <p className="mt-1 text-sm text-red-600">{errors.firstName}</p>}
//                   </div>

//                   <div>
//                     <label className="block text-sm font-medium text-gray-700 mb-2">Last Name</label>
//                     <div className="relative">
//                       <div className="absolute inset-y-0 left-0 pl-3 flex items-center pointer-events-none">
//                         <User className="h-5 w-5 text-gray-400" />
//                       </div>
//                       <input
//                         type="text"
//                         name="lastName"
//                         value={formData.lastName}
//                         onChange={handleInputChange}
//                         className={`
//                           w-full pl-10 pr-3 py-3 border rounded-lg
//                           ${errors.lastName ? 'border-red-300' : 'border-gray-300'}
//                         `}
//                         placeholder="Doe"
//                       />
//                     </div>
//                     {errors.lastName && <p className="mt-1 text-sm text-red-600">{errors.lastName}</p>}
//                   </div>
//                 </div>

//                 <div>
//                   <label className="block text-sm font-medium text-gray-700 mb-2">Email</label>
//                   <div className="relative">
//                     <div className="absolute inset-y-0 left-0 pl-3 flex items-center pointer-events-none">
//                       <Mail className="h-5 w-5 text-gray-400" />
//                     </div>
//                     <input
//                       type="email"
//                       name="email"
//                       value={formData.email}
//                       onChange={handleInputChange}
//                       className={`
//                         w-full pl-10 pr-3 py-3 border rounded-lg
//                         ${errors.email ? 'border-red-300' : 'border-gray-300'}
//                       `}
//                       placeholder="john@example.com"
//                     />
//                   </div>
//                   {errors.email && <p className="mt-1 text-sm text-red-600">{errors.email}</p>}
//                 </div>

//                 <div>
//                   <label className="block text-sm font-medium text-gray-700 mb-2">Phone</label>
//                   <div className="relative">
//                     <div className="absolute inset-y-0 left-0 pl-3 flex items-center pointer-events-none">
//                       <Phone className="h-5 w-5 text-gray-400" />
//                     </div>
//                     <input
//                       type="tel"
//                       name="phone"
//                       value={formData.phone}
//                       onChange={handleInputChange}
//                       className={`
//                         w-full pl-10 pr-3 py-3 border rounded-lg
//                         ${errors.phone ? 'border-red-300' : 'border-gray-300'}
//                       `}
//                       placeholder="+1 (555) 123-4567"
//                     />
//                   </div>
//                   {errors.phone && <p className="mt-1 text-sm text-red-600">{errors.phone}</p>}
//                 </div>

//                 <div>
//                   <label className="block text-sm font-medium text-gray-700 mb-2">Password</label>
//                   <div className="relative">
//                     <div className="absolute inset-y-0 left-0 pl-3 flex items-center pointer-events-none">
//                       <Lock className="h-5 w-5 text-gray-400" />
//                     </div>
//                     <input
//                       type={showPassword ? 'text' : 'password'}
//                       name="password"
//                       value={formData.password}
//                       onChange={handleInputChange}
//                       className={`
//                         w-full pl-10 pr-12 py-3 border rounded-lg
//                         ${errors.password ? 'border-red-300' : 'border-gray-300'}
//                       `}
//                       placeholder="••••••••"
//                     />
//                     <button
//                       type="button"
//                       onClick={() => setShowPassword(!showPassword)}
//                       className="absolute inset-y-0 right-0 pr-3 flex items-center"
//                     >
//                       {showPassword ? <EyeOff className="h-5 w-5 text-gray-400" /> : <Eye className="h-5 w-5 text-gray-400" />}
//                     </button>
//                   </div>
//                   {errors.password && <p className="mt-1 text-sm text-red-600">{errors.password}</p>}
//                 </div>

//                 <div>
//                   <label className="block text-sm font-medium text-gray-700 mb-2">Confirm Password</label>
//                   <div className="relative">
//                     <div className="absolute inset-y-0 left-0 pl-3 flex items-center pointer-events-none">
//                       <Lock className="h-5 w-5 text-gray-400" />
//                     </div>
//                     <input
//                       type={showConfirmPassword ? 'text' : 'password'}
//                       name="confirmPassword"
//                       value={formData.confirmPassword}
//                       onChange={handleInputChange}
//                       className={`
//                         w-full pl-10 pr-12 py-3 border rounded-lg
//                         ${errors.confirmPassword ? 'border-red-300' : 'border-gray-300'}
//                       `}
//                       placeholder="••••••••"
//                     />
//                     <button
//                       type="button"
//                       onClick={() => setShowConfirmPassword(!showConfirmPassword)}
//                       className="absolute inset-y-0 right-0 pr-3 flex items-center"
//                     >
//                       {showConfirmPassword ? <EyeOff className="h-5 w-5 text-gray-400" /> : <Eye className="h-5 w-5 text-gray-400" />}
//                     </button>
//                   </div>
//                   {errors.confirmPassword && <p className="mt-1 text-sm text-red-600">{errors.confirmPassword}</p>}
//                 </div>

//                 {/* Google Signup Option */}
//                 <div className="relative">
//                   <div className="absolute inset-0 flex items-center">
//                     <div className="w-full border-t border-gray-300"></div>
//                   </div>
//                   <div className="relative flex justify-center text-sm">
//                     <span className="px-2 bg-white text-gray-500">Or</span>
//                   </div>
//                 </div>

//                 <button
//                   type="button"
//                   onClick={() => googleSignup()}
//                   className="w-full flex items-center justify-center gap-3 border border-gray-300 rounded-lg py-3 px-4 hover:bg-gray-50"
//                 >
//                   <svg className="h-5 w-5" viewBox="0 0 24 24">
//                     <path d="M22.56 12.25c0-.78-.07-1.53-.2-2.25H12v4.26h5.92c-.26 1.37-1.04 2.53-2.21 3.31v2.77h3.57c2.08-1.92 3.28-4.74 3.28-8.09z" fill="#4285F4"/>
//                     <path d="M12 23c2.97 0 5.46-.98 7.28-2.66l-3.57-2.77c-.98.66-2.23 1.06-3.71 1.06-2.86 0-5.29-1.93-6.16-4.53H2.18v2.84C3.99 20.53 7.7 23 12 23z" fill="#34A853"/>
//                     <path d="M5.84 14.09c-.22-.66-.35-1.36-.35-2.09s.13-1.43.35-2.09V7.07H2.18C1.43 8.55 1 10.22 1 12s.43 3.45 1.18 4.93l2.85-2.22.81-.62z" fill="#FBBC05"/>
//                     <path d="M12 5.38c1.62 0 3.06.56 4.21 1.64l3.15-3.15C17.45 2.09 14.97 1 12 1 7.7 1 3.99 3.47 2.18 7.07l3.66 2.84c.87-2.6 3.3-4.53 6.16-4.53z" fill="#EA4335"/>
//                   </svg>
//                   <span className="font-medium text-gray-700">Sign up with Google</span>
//                 </button>
//               </div>
//             )}

//             {/* Step 2: Organization Details */}
//             {currentStep === 2 && (
//               <div className="space-y-4">
//                 <div>
//                   <label className="block text-sm font-medium text-gray-700 mb-2">Organization Name</label>
//                   <div className="relative">
//                     <div className="absolute inset-y-0 left-0 pl-3 flex items-center pointer-events-none">
//                       <Building2 className="h-5 w-5 text-gray-400" />
//                     </div>
//                     <input
//                       type="text"
//                       name="organizationName"
//                       value={formData.organizationName}
//                       onChange={handleInputChange}
//                       className={`
//                         w-full pl-10 pr-3 py-3 border rounded-lg
//                         ${errors.organizationName ? 'border-red-300' : 'border-gray-300'}
//                       `}
//                       placeholder="Acme Corporation"
//                     />
//                   </div>
//                   {errors.organizationName && <p className="mt-1 text-sm text-red-600">{errors.organizationName}</p>}
//                 </div>

//                 <div>
//                   <label className="block text-sm font-medium text-gray-700 mb-2">Portal Name</label>
//                   <div className="relative">
//                     <div className="absolute inset-y-0 left-0 pl-3 flex items-center pointer-events-none">
//                       <Link className="h-5 w-5 text-gray-400" />
//                     </div>
//                     <input
//                       type="text"
//                       name="portalName"
//                       value={formData.portalName}
//                       onChange={handleInputChange}
//                       className={`
//                         w-full pl-10 pr-32 py-3 border rounded-lg
//                         ${errors.portalName ? 'border-red-300' : 'border-gray-300'}
//                       `}
//                       placeholder="acmecorp"
//                     />
//                     <div className="absolute inset-y-0 right-0 pr-3 flex items-center">
//                       <span className="text-gray-500 text-sm">.cusobusiness.com</span>
//                     </div>
//                   </div>
//                   <div className="mt-1 flex items-center text-sm">
//                     {checkingPortal && <Loader2 className="animate-spin h-4 w-4 mr-2" />}
//                     {portalAvailable === true && <span className="text-green-600">✓ Available</span>}
//                     {portalAvailable === false && <span className="text-red-600">✗ Already taken</span>}
//                   </div>
//                   {errors.portalName && <p className="mt-1 text-sm text-red-600">{errors.portalName}</p>}
//                 </div>

//                 <div>
//                   <label className="block text-sm font-medium text-gray-700 mb-2">Industry</label>
//                   <div className="relative">
//                     <select
//                       name="industry"
//                       value={formData.industry}
//                       onChange={handleInputChange}
//                       className={`
//                         w-full px-3 py-3 border rounded-lg appearance-none
//                         ${errors.industry ? 'border-red-300' : 'border-gray-300'}
//                       `}
//                     >
//                       <option value="">Select industry</option>
//                       {industries.map(industry => (
//                         <option key={industry} value={industry}>{industry}</option>
//                       ))}
//                     </select>
//                     <ChevronDown className="absolute right-3 top-3.5 h-5 w-5 text-gray-400 pointer-events-none" />
//                   </div>
//                   {errors.industry && <p className="mt-1 text-sm text-red-600">{errors.industry}</p>}
//                 </div>

//                 <div>
//                   <label className="block text-sm font-medium text-gray-700 mb-2">Company Size</label>
//                   <div className="relative">
//                     <select
//                       name="companySize"
//                       value={formData.companySize}
//                       onChange={handleInputChange}
//                       className={`
//                         w-full px-3 py-3 border rounded-lg appearance-none
//                         ${errors.companySize ? 'border-red-300' : 'border-gray-300'}
//                       `}
//                     >
//                       <option value="">Select company size</option>
//                       {companySizes.map(size => (
//                         <option key={size} value={size}>{size}</option>
//                       ))}
//                     </select>
//                     <ChevronDown className="absolute right-3 top-3.5 h-5 w-5 text-gray-400 pointer-events-none" />
//                   </div>
//                   {errors.companySize && <p className="mt-1 text-sm text-red-600">{errors.companySize}</p>}
//                 </div>
//               </div>
//             )}

//             {/* Step 3: Settings & Confirmation */}
//             {currentStep === 3 && (
//               <div className="space-y-4">
//                 <div>
//                   <label className="block text-sm font-medium text-gray-700 mb-2">Country</label>
//                   <div className="relative">
//                     <div className="absolute inset-y-0 left-0 pl-3 flex items-center pointer-events-none">
//                       <Globe className="h-5 w-5 text-gray-400" />
//                     </div>
//                     <select
//                       name="country"
//                       value={formData.country}
//                       onChange={handleInputChange}
//                       className={`
//                         w-full pl-10 pr-3 py-3 border rounded-lg appearance-none
//                         ${errors.country ? 'border-red-300' : 'border-gray-300'}
//                       `}
//                     >
//                       <option value="">Select country</option>
//                       {countries.map(country => (
//                         <option key={country} value={country}>{country}</option>
//                       ))}
//                     </select>
//                     <ChevronDown className="absolute right-3 top-3.5 h-5 w-5 text-gray-400 pointer-events-none" />
//                   </div>
//                   {errors.country && <p className="mt-1 text-sm text-red-600">{errors.country}</p>}
//                 </div>

//                 <div>
//                   <label className="block text-sm font-medium text-gray-700 mb-2">Timezone</label>
//                   <div className="relative">
//                     <select
//                       name="timezone"
//                       value={formData.timezone}
//                       onChange={handleInputChange}
//                       className={`
//                         w-full px-3 py-3 border rounded-lg appearance-none
//                         ${errors.timezone ? 'border-red-300' : 'border-gray-300'}
//                       `}
//                     >
//                       <option value="">Select timezone</option>
//                       {timezones.map(tz => (
//                         <option key={tz.value} value={tz.value}>{tz.label}</option>
//                       ))}
//                     </select>
//                     <ChevronDown className="absolute right-3 top-3.5 h-5 w-5 text-gray-400 pointer-events-none" />
//                   </div>
//                   {errors.timezone && <p className="mt-1 text-sm text-red-600">{errors.timezone}</p>}
//                 </div>

//                 <div className="grid grid-cols-2 gap-4">
//                   <div>
//                     <label className="block text-sm font-medium text-gray-700 mb-2">Language</label>
//                     <select
//                       name="language"
//                       value={formData.language}
//                       onChange={handleInputChange}
//                       className="w-full px-3 py-3 border border-gray-300 rounded-lg appearance-none"
//                     >
//                       <option value="English">English</option>
//                       <option value="Spanish">Spanish</option>
//                       <option value="French">French</option>
//                       <option value="German">German</option>
//                     </select>
//                   </div>

//                   <div>
//                     <label className="block text-sm font-medium text-gray-700 mb-2">Currency</label>
//                     <select
//                       name="currency"
//                       value={formData.currency}
//                       onChange={handleInputChange}
//                       className="w-full px-3 py-3 border border-gray-300 rounded-lg appearance-none"
//                     >
//                       <option value="USD">USD ($)</option>
//                       <option value="EUR">EUR (€)</option>
//                       <option value="GBP">GBP (£)</option>
//                       <option value="INR">INR (₹)</option>
//                     </select>
//                   </div>
//                 </div>

//                 {/* Agreement Checkboxes */}
//                 <div className="space-y-3 pt-4">
//                   <div className="flex items-start">
//                     <input
//                       type="checkbox"
//                       id="terms"
//                       name="termsAccepted"
//                       checked={formData.termsAccepted}
//                       onChange={handleInputChange}
//                       className="h-4 w-4 mt-0.5 text-blue-600 border-gray-300 rounded"
//                     />
//                     <label htmlFor="terms" className="ml-2 text-sm text-gray-700">
//                       I agree to the{' '}
//                       <a href="/terms" className="text-blue-600 hover:text-blue-500">Terms of Service</a>
//                       {' '}and{' '}
//                       <a href="/privacy" className="text-blue-600 hover:text-blue-500">Privacy Policy</a>
//                     </label>
//                   </div>
//                   {errors.termsAccepted && <p className="text-sm text-red-600">{errors.termsAccepted}</p>}

//                   <div className="flex items-start">
//                     <input
//                       type="checkbox"
//                       id="marketing"
//                       name="marketingEmails"
//                       checked={formData.marketingEmails}
//                       onChange={handleInputChange}
//                       className="h-4 w-4 mt-0.5 text-blue-600 border-gray-300 rounded"
//                     />
//                     <label htmlFor="marketing" className="ml-2 text-sm text-gray-700">
//                       I'd like to receive marketing emails about product updates and special offers
//                     </label>
//                   </div>
//                 </div>
//               </div>
//             )}

//             {/* Navigation Buttons */}
//             <div className="mt-8 flex justify-between">
//               {currentStep > 1 && (
//                 <button
//                   type="button"
//                   onClick={handlePrevStep}
//                   className="px-6 py-3 border border-gray-300 rounded-lg text-gray-700 hover:bg-gray-50"
//                 >
//                   Previous
//                 </button>
//               )}

//               {currentStep < 3 ? (
//                 <button
//                   type="button"
//                   onClick={handleNextStep}
//                   className="ml-auto px-6 py-3 bg-blue-600 text-white rounded-lg hover:bg-blue-700"
//                 >
//                   Next
//                 </button>
//               ) : (
//                 <button
//                   type="submit"
//                   disabled={isLoading}
//                   className="ml-auto px-6 py-3 bg-gradient-to-r from-blue-600 to-blue-700 text-white rounded-lg hover:from-blue-700 hover:to-blue-800 disabled:opacity-50 flex items-center"
//                 >
//                   {isLoading ? (
//                     <>
//                       <Loader2 className="animate-spin -ml-1 mr-2 h-5 w-5" />
//                       Creating account...
//                     </>
//                   ) : (
//                     'Create Account'
//                   )}
//                 </button>
//               )}
//             </div>
//           </form>

//           {/* Login Link */}
//           <div className="mt-6 text-center text-sm">
//             <span className="text-gray-600">Already have an account? </span>
//             <a href="/login" className="text-blue-600 hover:text-blue-500 font-medium">
//               Sign in
//             </a>
//           </div>
//         </div>
//       </div>
//     </div>
//   );
// };

// export default SignUp;


// import React, { useState, useEffect, useMemo } from 'react';
// import { Eye, EyeOff, Mail, Lock, Loader2, Building2, User, Phone, Globe, ChevronDown, MapPin } from 'lucide-react';
// import { useGoogleLogin } from '@react-oauth/google';
// import axios from 'axios';
// import { toast } from 'react-toastify';
// import { useNavigate } from 'react-router-dom';
// import Logo from "../assets/images/Logo.png";
// import moment from 'moment-timezone';
// import { Country, State } from 'country-state-city';
// import Select from 'react-select';

// // Industries
// const industries = [
//   'Technology', 'Healthcare', 'Finance', 'Education', 'Retail',
//   'Manufacturing', 'Real Estate', 'Hospitality', 'Media & Entertainment',
//   'Transportation', 'Non-Profit', 'Government', 'Other'
// ];

// // Company sizes
// const companySizes = [
//   '1-10 employees',
//   '11-50 employees',
//   '51-200 employees',
//   '201-500 employees',
//   '501-1000 employees',
//   '1000+ employees'
// ];

// // Currency mapping by country code
// const currencyMap = {
//   'US': 'USD', 'GB': 'GBP', 'IN': 'INR', 'CA': 'CAD', 'AU': 'AUD',
//   'JP': 'JPY', 'CN': 'CNY', 'DE': 'EUR', 'FR': 'EUR', 'IT': 'EUR',
//   'ES': 'EUR', 'BR': 'BRL', 'MX': 'MXN', 'SG': 'SGD', 'AE': 'AED',
//   'ZA': 'ZAR', 'CH': 'CHF', 'SE': 'SEK', 'NZ': 'NZD', 'KR': 'KRW'
// };

// const SignUp = () => {
//   const [currentStep, setCurrentStep] = useState(1);
//   const [formData, setFormData] = useState({
//     // Personal Information
//     firstName: '',
//     lastName: '',
//     email: '',
//     phone: '',
//     password: '',
//     confirmPassword: '',

//     // Organization Information
//     organizationName: '',
//     industry: '',
//     companySize: '',

//     // Location & Settings
//     country: '',
//     state: '',
//     timezone: '',
//     currency: 'USD',

//     // Agreement
//     termsAccepted: false,
//     marketingEmails: false
//   });

//   const [errors, setErrors] = useState({});
//   const [showPassword, setShowPassword] = useState(false);
//   const [showConfirmPassword, setShowConfirmPassword] = useState(false);
//   const [isLoading, setIsLoading] = useState(false);
//   const [states, setStates] = useState([]);
//   const navigate = useNavigate();

//   // Get all countries
//   const countries = useMemo(() => {
//     return Country.getAllCountries().map(country => ({
//       value: country.isoCode,
//       label: country.name,
//       currency: country.currency,
//       phonecode: country.phonecode,
//       flag: country.flag
//     }));
//   }, []);

//   // Get timezones dynamically
//   const timezones = useMemo(() => {
//     const tzNames = moment.tz.names();
//     const now = moment();

//     return tzNames.map(tz => {
//       const offset = moment.tz(tz).format('Z');
//       const offsetHours = moment.tz(tz).utcOffset() / 60;
//       const sign = offsetHours >= 0 ? '+' : '';

//       return {
//         value: tz,
//         label: `(UTC${sign}${offset}) ${tz.replace(/_/g, ' ').replace(/\//g, ' - ')}`,
//         offset: offsetHours
//       };
//     }).sort((a, b) => a.offset - b.offset);
//   }, []);

//   // Auto-detect user's timezone
//   useEffect(() => {
//     const userTimezone = moment.tz.guess();
//     if (userTimezone && !formData.timezone) {
//       setFormData(prev => ({ ...prev, timezone: userTimezone }));
//     }
//   }, []);

//   // Update states when country changes
//   useEffect(() => {
//     if (formData.country) {
//       // Get states for selected country
//       const countryStates = State.getStatesOfCountry(formData.country).map(state => ({
//         value: state.isoCode,
//         label: state.name
//       }));
//       setStates(countryStates);

//       // Clear state selection when country changes
//       setFormData(prev => ({ ...prev, state: '' }));

//       // Auto-set currency based on country
//       const currency = currencyMap[formData.country] || 'USD';
//       setFormData(prev => ({ ...prev, currency }));
//     } else {
//       setStates([]);
//     }
//   }, [formData.country]);

//   // Validate email format
//   const validateEmail = (email) => {
//     const emailRegex = /^[^\s@]+@[^\s@]+\.[^\s@]+$/;
//     return emailRegex.test(email);
//   };

//   // Validate phone number format
//   const validatePhone = (phone) => {
//     const phoneRegex = /^[+]?[(]?[0-9]{1,3}[)]?[-\s\.]?[(]?[0-9]{1,4}[)]?[-\s\.]?[0-9]{1,4}[-\s\.]?[0-9]{1,9}$/;
//     return phoneRegex.test(phone);
//   };

//   // Validate form based on current step
//   const validateStep = () => {
//     const newErrors = {};

//     if (currentStep === 1) {
//       // Personal Information validation
//       if (!formData.firstName.trim()) newErrors.firstName = 'First name is required';
//       if (!formData.lastName.trim()) newErrors.lastName = 'Last name is required';
//       if (!formData.email.trim()) {
//         newErrors.email = 'Email is required';
//       } else if (!validateEmail(formData.email)) {
//         newErrors.email = 'Please enter a valid email address';
//       }
//       if (!formData.phone.trim()) {
//         newErrors.phone = 'Phone number is required';
//       } else if (!validatePhone(formData.phone)) {
//         newErrors.phone = 'Please enter a valid phone number';
//       }
//       if (!formData.password) {
//         newErrors.password = 'Password is required';
//       } else if (formData.password.length < 8) {
//         newErrors.password = 'Password must be at least 8 characters';
//       } else if (!/(?=.*[a-z])(?=.*[A-Z])(?=.*\d)/.test(formData.password)) {
//         newErrors.password = 'Password must contain uppercase, lowercase and numbers';
//       }
//       if (formData.password !== formData.confirmPassword) {
//         newErrors.confirmPassword = 'Passwords do not match';
//       }
//     } else if (currentStep === 2) {
//       // Organization Information validation
//       if (!formData.organizationName.trim()) newErrors.organizationName = 'Organization name is required';
//       if (!formData.industry) newErrors.industry = 'Please select an industry';
//       if (!formData.companySize) newErrors.companySize = 'Please select company size';
//     } else if (currentStep === 3) {
//       // Location & Settings validation
//       if (!formData.country) newErrors.country = 'Please select a country';
//       if (!formData.timezone) newErrors.timezone = 'Please select a timezone';
//       if (!formData.termsAccepted) newErrors.termsAccepted = 'You must accept the terms and conditions';
//     }

//     setErrors(newErrors);
//     return Object.keys(newErrors).length === 0;
//   };

//   // Handle input changes
//   const handleInputChange = (e) => {
//     const { name, value, type, checked } = e.target;
//     setFormData(prev => ({
//       ...prev,
//       [name]: type === 'checkbox' ? checked : value
//     }));

//     // Clear error for the field being edited
//     if (errors[name]) {
//       setErrors(prev => ({
//         ...prev,
//         [name]: ''
//       }));
//     }
//   };

//   // Handle select changes for react-select
//   const handleSelectChange = (name, selectedOption) => {
//     setFormData(prev => ({
//       ...prev,
//       [name]: selectedOption ? selectedOption.value : ''
//     }));

//     if (errors[name]) {
//       setErrors(prev => ({
//         ...prev,
//         [name]: ''
//       }));
//     }
//   };

//   // Handle next step
//   const handleNextStep = () => {
//     if (validateStep()) {
//       setCurrentStep(prev => prev + 1);
//     }
//   };

//   // Handle previous step
//   const handlePrevStep = () => {
//     setCurrentStep(prev => prev - 1);
//   };

//   // Handle form submission
//   const handleSubmit = async (e) => {
//     e.preventDefault();

//     if (!validateStep()) {
//       return;
//     }

//     setIsLoading(true);

//     try {
//       // Prepare data for submission
//       const submitData = {
//         ...formData,
//         // Get country name instead of code if needed
//         countryName: countries.find(c => c.value === formData.country)?.label,
//         // Get state name instead of code if needed
//         stateName: states.find(s => s.value === formData.state)?.label
//       };

//       const { data } = await axios.post('http://localhost:8080/api/signup', submitData);

//       localStorage.setItem('token', data.token);
//       localStorage.setItem('user', JSON.stringify(data.user));
//       toast.success('Account created successfully!');

//       navigate('/onboarding');

//     } catch (error) {
//       if (error.response?.data?.message) {
//         toast.error(error.response.data.message);
//       } else {
//         toast.error('Signup failed. Please try again.');
//       }
//     } finally {
//       setIsLoading(false);
//     }
//   };

//   // Google Signup
//   const googleSignup = useGoogleLogin({
//     onSuccess: async (tokenResponse) => {
//       try {
//         const { access_token } = tokenResponse;
//         const { data } = await axios.post('http://localhost:8080/api/google-signup', {
//           token: access_token,
//         });

//         // Pre-fill form with Google data
//         setFormData(prev => ({
//           ...prev,
//           email: data.email,
//           firstName: data.given_name || '',
//           lastName: data.family_name || ''
//         }));

//         toast.info('Please complete your organization details');
//         setCurrentStep(2);

//       } catch (error) {
//         toast.error('Google signup failed.');
//       }
//     },
//     onError: () => {
//       toast.error('Google signup error');
//     }
//   });

//   // Custom styles for react-select
//   const selectStyles = {
//     control: (base, state) => ({
//       ...base,
//       padding: '0.25rem',
//       borderColor: errors[state.selectProps.name] ? '#fca5a5' : '#d1d5db',
//       '&:hover': {
//         borderColor: state.isFocused ? '#3b82f6' : '#9ca3af'
//       }
//     }),
//     menu: (base) => ({
//       ...base,
//       zIndex: 9999
//     })
//   };

//   return (
//     <div className="min-h-screen relative overflow-hidden bg-gradient-to-br from-blue-50 via-green-50 to-yellow-50">
//       {/* Background Pattern */}
//       <div className="absolute inset-0 opacity-10">
//         <div 
//           className="absolute inset-0" 
//           style={{
//             backgroundImage: `
//               repeating-linear-gradient(45deg, transparent, transparent 35px, rgba(59, 130, 246, 0.1) 35px, rgba(59, 130, 246, 0.1) 70px),
//               repeating-linear-gradient(-45deg, transparent, transparent 35px, rgba(239, 68, 68, 0.1) 35px, rgba(239, 68, 68, 0.1) 70px),
//               repeating-linear-gradient(90deg, transparent, transparent 50px, rgba(34, 197, 94, 0.1) 50px, rgba(34, 197, 94, 0.1) 100px)
//             `
//           }}
//         />
//         <div className="absolute top-20 left-20 w-24 h-24 bg-blue-500 opacity-10 rounded-lg transform rotate-45"></div>
//         <div className="absolute top-40 right-40 w-32 h-32 bg-red-500 opacity-10 rounded-lg transform rotate-12"></div>
//         <div className="absolute bottom-20 left-1/3 w-28 h-28 bg-green-500 opacity-10 rounded-lg transform -rotate-12"></div>
//         <div className="absolute bottom-40 right-20 w-20 h-20 bg-yellow-500 opacity-10 rounded-lg transform rotate-45"></div>
//       </div>

//       <div className="relative flex items-center justify-center min-h-screen p-4">
//         <div className="bg-white rounded-2xl shadow-2xl w-full max-w-2xl p-8 backdrop-blur-sm my-8">
//           {/* Header */}
//           <div className="text-center mb-6">
//             <div className="flex justify-center mb-4">
//               <img src={Logo} alt="Cuso Business Logo" className="w-12 h-12"/>
//             </div>
//             <h1 className="text-3xl font-bold text-gray-900 mb-2">Create your account</h1>
//             <p className="text-gray-600">Start your 14-day free trial</p>

//             {/* Progress Steps */}
//             <div className="mt-6 flex items-center justify-center space-x-2">
//               {[1, 2, 3].map((step) => (
//                 <React.Fragment key={step}>
//                   <div className={`
//                     w-8 h-8 rounded-full flex items-center justify-center text-sm font-medium
//                     ${currentStep >= step 
//                       ? 'bg-blue-600 text-white' 
//                       : 'bg-gray-200 text-gray-500'}
//                   `}>
//                     {step}
//                   </div>
//                   {step < 3 && (
//                     <div className={`w-16 h-1 ${currentStep > step ? 'bg-blue-600' : 'bg-gray-200'}`} />
//                   )}
//                 </React.Fragment>
//               ))}
//             </div>
//             <div className="mt-2 text-sm text-gray-600">
//               {currentStep === 1 && "Personal Information"}
//               {currentStep === 2 && "Organization Details"}
//               {currentStep === 3 && "Location & Preferences"}
//             </div>
//           </div>

//           {/* Form */}
//           <form onSubmit={handleSubmit}>
//             {/* Step 1: Personal Information */}
//             {currentStep === 1 && (
//               <div className="space-y-4">
//                 <div className="grid grid-cols-2 gap-4">
//                   <div>
//                     <label className="block text-sm font-medium text-gray-700 mb-2">First Name</label>
//                     <div className="relative">
//                       <div className="absolute inset-y-0 left-0 pl-3 flex items-center pointer-events-none">
//                         <User className="h-5 w-5 text-gray-400" />
//                       </div>
//                       <input
//                         type="text"
//                         name="firstName"
//                         value={formData.firstName}
//                         onChange={handleInputChange}
//                         className={`
//                           w-full pl-10 pr-3 py-3 border rounded-lg
//                           ${errors.firstName ? 'border-red-300' : 'border-gray-300'}
//                         `}
//                         placeholder="John"
//                       />
//                     </div>
//                     {errors.firstName && <p className="mt-1 text-sm text-red-600">{errors.firstName}</p>}
//                   </div>

//                   <div>
//                     <label className="block text-sm font-medium text-gray-700 mb-2">Last Name</label>
//                     <div className="relative">
//                       <div className="absolute inset-y-0 left-0 pl-3 flex items-center pointer-events-none">
//                         <User className="h-5 w-5 text-gray-400" />
//                       </div>
//                       <input
//                         type="text"
//                         name="lastName"
//                         value={formData.lastName}
//                         onChange={handleInputChange}
//                         className={`
//                           w-full pl-10 pr-3 py-3 border rounded-lg
//                           ${errors.lastName ? 'border-red-300' : 'border-gray-300'}
//                         `}
//                         placeholder="Doe"
//                       />
//                     </div>
//                     {errors.lastName && <p className="mt-1 text-sm text-red-600">{errors.lastName}</p>}
//                   </div>
//                 </div>

//                 <div>
//                   <label className="block text-sm font-medium text-gray-700 mb-2">Email</label>
//                   <div className="relative">
//                     <div className="absolute inset-y-0 left-0 pl-3 flex items-center pointer-events-none">
//                       <Mail className="h-5 w-5 text-gray-400" />
//                     </div>
//                     <input
//                       type="email"
//                       name="email"
//                       value={formData.email}
//                       onChange={handleInputChange}
//                       className={`
//                         w-full pl-10 pr-3 py-3 border rounded-lg
//                         ${errors.email ? 'border-red-300' : 'border-gray-300'}
//                       `}
//                       placeholder="john@example.com"
//                     />
//                   </div>
//                   {errors.email && <p className="mt-1 text-sm text-red-600">{errors.email}</p>}
//                 </div>

//                 <div>
//                   <label className="block text-sm font-medium text-gray-700 mb-2">Phone</label>
//                   <div className="relative">
//                     <div className="absolute inset-y-0 left-0 pl-3 flex items-center pointer-events-none">
//                       <Phone className="h-5 w-5 text-gray-400" />
//                     </div>
//                     <input
//                       type="tel"
//                       name="phone"
//                       value={formData.phone}
//                       onChange={handleInputChange}
//                       className={`
//                         w-full pl-10 pr-3 py-3 border rounded-lg
//                         ${errors.phone ? 'border-red-300' : 'border-gray-300'}
//                       `}
//                       placeholder="+1 (555) 123-4567"
//                     />
//                   </div>
//                   {errors.phone && <p className="mt-1 text-sm text-red-600">{errors.phone}</p>}
//                 </div>

//                 <div>
//                   <label className="block text-sm font-medium text-gray-700 mb-2">Password</label>
//                   <div className="relative">
//                     <div className="absolute inset-y-0 left-0 pl-3 flex items-center pointer-events-none">
//                       <Lock className="h-5 w-5 text-gray-400" />
//                     </div>
//                     <input
//                       type={showPassword ? 'text' : 'password'}
//                       name="password"
//                       value={formData.password}
//                       onChange={handleInputChange}
//                       className={`
//                         w-full pl-10 pr-12 py-3 border rounded-lg
//                         ${errors.password ? 'border-red-300' : 'border-gray-300'}
//                       `}
//                       placeholder="••••••••"
//                     />
//                     <button
//                       type="button"
//                       onClick={() => setShowPassword(!showPassword)}
//                       className="absolute inset-y-0 right-0 pr-3 flex items-center"
//                     >
//                       {showPassword ? <EyeOff className="h-5 w-5 text-gray-400" /> : <Eye className="h-5 w-5 text-gray-400" />}
//                     </button>
//                   </div>
//                   {errors.password && <p className="mt-1 text-sm text-red-600">{errors.password}</p>}
//                 </div>

//                 <div>
//                   <label className="block text-sm font-medium text-gray-700 mb-2">Confirm Password</label>
//                   <div className="relative">
//                     <div className="absolute inset-y-0 left-0 pl-3 flex items-center pointer-events-none">
//                       <Lock className="h-5 w-5 text-gray-400" />
//                     </div>
//                     <input
//                       type={showConfirmPassword ? 'text' : 'password'}
//                       name="confirmPassword"
//                       value={formData.confirmPassword}
//                       onChange={handleInputChange}
//                       className={`
//                         w-full pl-10 pr-12 py-3 border rounded-lg
//                         ${errors.confirmPassword ? 'border-red-300' : 'border-gray-300'}
//                       `}
//                       placeholder="••••••••"
//                     />
//                     <button
//                       type="button"
//                       onClick={() => setShowConfirmPassword(!showConfirmPassword)}
//                       className="absolute inset-y-0 right-0 pr-3 flex items-center"
//                     >
//                       {showConfirmPassword ? <EyeOff className="h-5 w-5 text-gray-400" /> : <Eye className="h-5 w-5 text-gray-400" />}
//                     </button>
//                   </div>
//                   {errors.confirmPassword && <p className="mt-1 text-sm text-red-600">{errors.confirmPassword}</p>}
//                 </div>

//                 {/* Google Signup Option */}
//                 <div className="relative">
//                   <div className="absolute inset-0 flex items-center">
//                     <div className="w-full border-t border-gray-300"></div>
//                   </div>
//                   <div className="relative flex justify-center text-sm">
//                     <span className="px-2 bg-white text-gray-500">Or</span>
//                   </div>
//                 </div>

//                 <button
//                   type="button"
//                   onClick={() => googleSignup()}
//                   className="w-full flex items-center justify-center gap-3 border border-gray-300 rounded-lg py-3 px-4 hover:bg-gray-50"
//                 >
//                   <svg className="h-5 w-5" viewBox="0 0 24 24">
//                     <path d="M22.56 12.25c0-.78-.07-1.53-.2-2.25H12v4.26h5.92c-.26 1.37-1.04 2.53-2.21 3.31v2.77h3.57c2.08-1.92 3.28-4.74 3.28-8.09z" fill="#4285F4"/>
//                     <path d="M12 23c2.97 0 5.46-.98 7.28-2.66l-3.57-2.77c-.98.66-2.23 1.06-3.71 1.06-2.86 0-5.29-1.93-6.16-4.53H2.18v2.84C3.99 20.53 7.7 23 12 23z" fill="#34A853"/>
//                     <path d="M5.84 14.09c-.22-.66-.35-1.36-.35-2.09s.13-1.43.35-2.09V7.07H2.18C1.43 8.55 1 10.22 1 12s.43 3.45 1.18 4.93l2.85-2.22.81-.62z" fill="#FBBC05"/>
//                     <path d="M12 5.38c1.62 0 3.06.56 4.21 1.64l3.15-3.15C17.45 2.09 14.97 1 12 1 7.7 1 3.99 3.47 2.18 7.07l3.66 2.84c.87-2.6 3.3-4.53 6.16-4.53z" fill="#EA4335"/>
//                   </svg>
//                   <span className="font-medium text-gray-700">Sign up with Google</span>
//                 </button>
//               </div>
//             )}

//             {/* Step 2: Organization Details */}
//             {currentStep === 2 && (
//               <div className="space-y-4">
//                 <div>
//                   <label className="block text-sm font-medium text-gray-700 mb-2">Organization Name</label>
//                   <div className="relative">
//                     <div className="absolute inset-y-0 left-0 pl-3 flex items-center pointer-events-none">
//                       <Building2 className="h-5 w-5 text-gray-400" />
//                     </div>
//                     <input
//                       type="text"
//                       name="organizationName"
//                       value={formData.organizationName}
//                       onChange={handleInputChange}
//                       className={`
//                         w-full pl-10 pr-3 py-3 border rounded-lg
//                         ${errors.organizationName ? 'border-red-300' : 'border-gray-300'}
//                       `}
//                       placeholder="Acme Corporation"
//                     />
//                   </div>
//                   {errors.organizationName && <p className="mt-1 text-sm text-red-600">{errors.organizationName}</p>}
//                 </div>

//                 <div>
//                   <label className="block text-sm font-medium text-gray-700 mb-2">Industry</label>
//                   <div className="relative">
//                     <select
//                       name="industry"
//                       value={formData.industry}
//                       onChange={handleInputChange}
//                       className={`
//                         w-full px-3 py-3 border rounded-lg appearance-none
//                         ${errors.industry ? 'border-red-300' : 'border-gray-300'}
//                       `}
//                     >
//                       <option value="">Select industry</option>
//                       {industries.map(industry => (
//                         <option key={industry} value={industry}>{industry}</option>
//                       ))}
//                     </select>
//                     <ChevronDown className="absolute right-3 top-3.5 h-5 w-5 text-gray-400 pointer-events-none" />
//                   </div>
//                   {errors.industry && <p className="mt-1 text-sm text-red-600">{errors.industry}</p>}
//                 </div>

//                 <div>
//                   <label className="block text-sm font-medium text-gray-700 mb-2">Company Size</label>
//                   <div className="relative">
//                     <select
//                       name="companySize"
//                       value={formData.companySize}
//                       onChange={handleInputChange}
//                       className={`
//                         w-full px-3 py-3 border rounded-lg appearance-none
//                         ${errors.companySize ? 'border-red-300' : 'border-gray-300'}
//                       `}
//                     >
//                       <option value="">Select company size</option>
//                       {companySizes.map(size => (
//                         <option key={size} value={size}>{size}</option>
//                       ))}
//                     </select>
//                     <ChevronDown className="absolute right-3 top-3.5 h-5 w-5 text-gray-400 pointer-events-none" />
//                   </div>
//                   {errors.companySize && <p className="mt-1 text-sm text-red-600">{errors.companySize}</p>}
//                 </div>
//               </div>
//             )}

//             {/* Step 3: Location & Preferences */}
//             {currentStep === 3 && (
//               <div className="space-y-4">
//                 <div>
//                   <label className="block text-sm font-medium text-gray-700 mb-2">Country</label>
//                   <Select
//                     name="country"
//                     value={countries.find(c => c.value === formData.country)}
//                     onChange={(option) => handleSelectChange('country', option)}
//                     options={countries}
//                     placeholder="Select country"
//                     isClearable
//                     isSearchable
//                     styles={selectStyles}
//                     className="react-select-container"
//                     classNamePrefix="react-select"
//                   />
//                   {errors.country && <p className="mt-1 text-sm text-red-600">{errors.country}</p>}
//                 </div>

//                 {/* State field - only show if country has states */}
//                 {formData.country && states.length > 0 && (
//                   <div>
//                     <label className="block text-sm font-medium text-gray-700 mb-2">State/Province</label>
//                     <Select
//                       name="state"
//                       value={states.find(s => s.value === formData.state)}
//                       onChange={(option) => handleSelectChange('state', option)}
//                       options={states}
//                       placeholder="Select state"
//                       isClearable
//                       isSearchable
//                       styles={selectStyles}
//                       className="react-select-container"
//                       classNamePrefix="react-select"
//                     />
//                     {errors.state && <p className="mt-1 text-sm text-red-600">{errors.state}</p>}
//                   </div>
//                 )}

//                 <div>
//                   <label className="block text-sm font-medium text-gray-700 mb-2">Timezone</label>
//                   <Select
//                     name="timezone"
//                     value={timezones.find(tz => tz.value === formData.timezone)}
//                     onChange={(option) => handleSelectChange('timezone', option)}
//                     options={timezones}
//                     placeholder="Select timezone"
//                     isClearable
//                     isSearchable
//                     styles={selectStyles}
//                     className="react-select-container"
//                     classNamePrefix="react-select"
//                   />
//                   {errors.timezone && <p className="mt-1 text-sm text-red-600">{errors.timezone}</p>}
//                 </div>

//                 {/* Display detected currency based on country */}
//                 {formData.country && (
//                   <div className="bg-gray-50 p-3 rounded-lg">
//                     <p className="text-sm text-gray-600">
//                       Currency: <span className="font-medium text-gray-900">{formData.currency}</span>
//                     </p>
//                   </div>
//                 )}

//                 {/* Agreement Checkboxes */}
//                 <div className="space-y-3 pt-4">
//                   <div className="flex items-start">
//                     <input
//                       type="checkbox"
//                       id="terms"
//                       name="termsAccepted"
//                       checked={formData.termsAccepted}
//                       onChange={handleInputChange}
//                       className="h-4 w-4 mt-0.5 text-blue-600 border-gray-300 rounded"
//                     />
//                     <label htmlFor="terms" className="ml-2 text-sm text-gray-700">
//                       I agree to the{' '}
//                       <a href="/terms" className="text-blue-600 hover:text-blue-500">Terms of Service</a>
//                       {' '}and{' '}
//                       <a href="/privacy" className="text-blue-600 hover:text-blue-500">Privacy Policy</a>
//                     </label>
//                   </div>
//                   {errors.termsAccepted && <p className="text-sm text-red-600">{errors.termsAccepted}</p>}

//                   <div className="flex items-start">
//                     <input
//                       type="checkbox"
//                       id="marketing"
//                       name="marketingEmails"
//                       checked={formData.marketingEmails}
//                       onChange={handleInputChange}
//                       className="h-4 w-4 mt-0.5 text-blue-600 border-gray-300 rounded"
//                     />
//                     <label htmlFor="marketing" className="ml-2 text-sm text-gray-700">
//                       I'd like to receive marketing emails about product updates and special offers
//                     </label>
//                   </div>
//                 </div>
//               </div>
//             )}

//             {/* Navigation Buttons */}
//             <div className="mt-8 flex justify-between">
//               {currentStep > 1 && (
//                 <button
//                   type="button"
//                   onClick={handlePrevStep}
//                   className="px-6 py-3 border border-gray-300 rounded-lg text-gray-700 hover:bg-gray-50"
//                 >
//                   Previous
//                 </button>
//               )}

//               {currentStep < 3 ? (
//                 <button
//                   type="button"
//                   onClick={handleNextStep}
//                   className="ml-auto px-6 py-3 bg-blue-600 text-white rounded-lg hover:bg-blue-700"
//                 >
//                   Next
//                 </button>
//               ) : (
//                 <button
//                   type="submit"
//                   disabled={isLoading}
//                   className="ml-auto px-6 py-3 bg-gradient-to-r from-blue-600 to-blue-700 text-white rounded-lg hover:from-blue-700 hover:to-blue-800 disabled:opacity-50 flex items-center"
//                 >
//                   {isLoading ? (
//                     <>
//                       <Loader2 className="animate-spin -ml-1 mr-2 h-5 w-5" />
//                       Creating account...
//                     </>
//                   ) : (
//                     'Create Account'
//                   )}
//                 </button>
//               )}
//             </div>
//           </form>

//           {/* Login Link */}
//           <div className="mt-6 text-center text-sm">
//             <span className="text-gray-600">Already have an account? </span>
//             <a href="/login" className="text-blue-600 hover:text-blue-500 font-medium">
//               Sign in
//             </a>
//           </div>
//         </div>
//       </div>
//     </div>
//   );
// };

// export default SignUp;

import React, { useState, useEffect, useMemo } from 'react';
import { Eye, EyeOff, Mail, Lock, Loader2, Building2, User } from 'lucide-react';
import { useGoogleLogin } from '@react-oauth/google';
import axios from 'axios';
import { toast } from 'react-toastify';
import { useNavigate } from 'react-router-dom';
import Logo2 from "../assets/images/Logo2.png";
import moment from 'moment-timezone';
import { Country, State } from 'country-state-city';
import Select from 'react-select';
import PhoneInput from 'react-phone-input-2';
import 'react-phone-input-2/lib/style.css';
import api from '../common/apiClient';
import SummaryApi from '../common/SummaryApi';

// Industries
const industries = [
    'Technology', 'Healthcare', 'Finance', 'Education', 'Retail',
    'Manufacturing', 'Real Estate', 'Hospitality', 'Media & Entertainment',
    'Transportation', 'Non-Profit', 'Government', 'Other'
];

// Company sizes
const companySizes = [
    '1-10 employees',
    '11-50 employees',
    '51-200 employees',
    '201-500 employees',
    '501-1000 employees',
    '1000+ employees'
];

// Currency mapping by country code
const currencyMap = {
    'US': 'USD', 'GB': 'GBP', 'IN': 'INR', 'CA': 'CAD', 'AU': 'AUD',
    'JP': 'JPY', 'CN': 'CNY', 'DE': 'EUR', 'FR': 'EUR', 'IT': 'EUR',
    'ES': 'EUR', 'BR': 'BRL', 'MX': 'MXN', 'SG': 'SGD', 'AE': 'AED',
    'ZA': 'ZAR', 'CH': 'CHF', 'SE': 'SEK', 'NZ': 'NZD', 'KR': 'KRW'
};

const SignUp = () => {
    const [currentStep, setCurrentStep] = useState(1);
    const [formData, setFormData] = useState({
        // Personal Information
        firstName: '',
        lastName: '',
        email: '',
        phone: '',
        password: '',
        confirmPassword: '',

        // Organization Information
        organizationName: '',
        industry: '',
        companySize: '',

        // Location & Settings
        country: '',
        state: '',
        timezone: '',
        currency: 'INR',

        // Agreement
        termsAccepted: false,
        marketingEmails: false
    });

    const [errors, setErrors] = useState({});
    const [showPassword, setShowPassword] = useState(false);
    const [showConfirmPassword, setShowConfirmPassword] = useState(false);
    const [isLoading, setIsLoading] = useState(false);
    const [states, setStates] = useState([]);
    const [finalValidation, setFinalValidation] = useState(false);
    const navigate = useNavigate();

    // Get all countries
    const countries = useMemo(() => {
        return Country.getAllCountries().map(country => ({
            value: country.isoCode,
            label: country.name
        }));
    }, []);

    // Get timezones dynamically
    const timezones = useMemo(() => {
        const tzNames = moment.tz.names();

        return tzNames.map(tz => {
            const offset = moment.tz(tz).format('Z');
            const offsetHours = moment.tz(tz).utcOffset() / 60;
            const sign = offsetHours >= 0 ? '+' : '';

            return {
                value: tz,
                label: `(UTC${sign}${offset}) ${tz.replace(/_/g, ' ').replace(/\//g, ' - ')}`,
                offset: offsetHours
            };
        }).sort((a, b) => a.offset - b.offset);
    }, []);

    // Auto-detect user's timezone
    useEffect(() => {
        const userTimezone = moment.tz.guess();
        if (userTimezone && !formData.timezone) {
            setFormData(prev => ({ ...prev, timezone: userTimezone }));
        }
    }, [formData.timezone]);

    // Update states when country changes
    useEffect(() => {
        if (formData.country) {
            // Get states for selected country
            const countryStates = State.getStatesOfCountry(formData.country).map(state => ({
                value: state.isoCode,
                label: state.name
            }));
            setStates(countryStates);

            // Clear state selection when country changes
            setFormData(prev => ({ ...prev, state: '' }));

            // Auto-set currency based on country
            const currency = currencyMap[formData.country] || 'USD';
            setFormData(prev => ({ ...prev, currency }));
        } else {
            setStates([]);
        }
    }, [formData.country]);

    // Validate email format
    const validateEmail = (email) => {
        const emailRegex = /^[^\s@]+@[^\s@]+\.[^\s@]+$/;
        return emailRegex.test(email);
    };

    // Validate phone number
    const validatePhone = (phone) => {
        // react-phone-input-2 returns the phone with country code
        // Minimum 10 digits after country code
        return phone && phone.length >= 10;
    };

    // Validate form based on current step
    const validateStep = (isSubmit = false) => {
        const newErrors = {};

        if (currentStep === 1 || isSubmit) {
            // Personal Information validation
            if (!formData.firstName.trim()) newErrors.firstName = 'First name is required';
            if (!formData.lastName.trim()) newErrors.lastName = 'Last name is required';
            if (!formData.email.trim()) {
                newErrors.email = 'Email is required';
            } else if (!validateEmail(formData.email)) {
                newErrors.email = 'Please enter a valid email address';
            }
            if (!validatePhone(formData.phone)) {
                newErrors.phone = 'Please enter a valid phone number';
            }
            if (!formData.password) {
                newErrors.password = 'Password is required';
            } else if (formData.password.length < 8) {
                newErrors.password = 'Password must be at least 8 characters';
            } else if (!/(?=.*[a-z])(?=.*[A-Z])(?=.*\d)/.test(formData.password)) {
                newErrors.password = 'Password must contain uppercase, lowercase and numbers';
            }
            if (formData.password !== formData.confirmPassword) {
                newErrors.confirmPassword = 'Passwords do not match';
            }
        }

        if ((currentStep === 2 && !isSubmit) || isSubmit) {
            // Organization Information validation
            if (!formData.organizationName.trim()) newErrors.organizationName = 'Organization name is required';
            if (!formData.industry) newErrors.industry = 'Please select an industry';
            if (!formData.companySize) newErrors.companySize = 'Please select company size';
        }

        if (currentStep === 3 && isSubmit) {
            // Only validate step 3 on final submit
            if (!formData.country) newErrors.country = 'Please select a country';
            if (!formData.timezone) newErrors.timezone = 'Please select a timezone';
            if (!formData.termsAccepted) newErrors.termsAccepted = 'You must accept the terms and conditions';
        }

        setErrors(newErrors);
        return Object.keys(newErrors).length === 0;
    };

    // Handle input changes
    const handleInputChange = (e) => {
        const { name, value, type, checked } = e.target;
        setFormData(prev => ({
            ...prev,
            [name]: type === 'checkbox' ? checked : value
        }));

        // Clear error for the field being edited
        if (errors[name]) {
            setErrors(prev => ({
                ...prev,
                [name]: ''
            }));
        }
    };

    // Handle phone change
    const handlePhoneChange = (value) => {
        setFormData(prev => ({
            ...prev,
            phone: value || ''
        }));

        if (errors.phone) {
            setErrors(prev => ({
                ...prev,
                phone: ''
            }));
        }
    };

    // Handle select changes for react-select
    const handleSelectChange = (name, selectedOption) => {
        setFormData(prev => ({
            ...prev,
            [name]: selectedOption ? selectedOption.value : ''
        }));

        if (errors[name]) {
            setErrors(prev => ({
                ...prev,
                [name]: ''
            }));
        }
    };

    // Handle next step
    const handleNextStep = () => {
        if (validateStep(false)) {
            setCurrentStep(prev => prev + 1);
            setFinalValidation(false);
        }
    };

    // Handle previous step
    const handlePrevStep = () => {
        setCurrentStep(prev => prev - 1);
        setFinalValidation(false);
    };

    // Handle form submission
    // Update the handleSubmit function in your SignUp component
    const handleSubmit = async (e) => {
        e.preventDefault();
        setFinalValidation(true);

        if (!validateStep(true)) {
            return;
        }

        setIsLoading(true);

        try {
            // Prepare data according to backend expectations
            const submitData = {
                // Personal Information
                firstName: formData.firstName,
                lastName: formData.lastName,
                email: formData.email,
                mobile: formData.phone, // Backend expects 'mobile' not 'phone'
                password: formData.password,
                confirmPassword: formData.confirmPassword,

                // Organization Information
                organizationName: formData.organizationName,
                organizationEmail: formData.email, // Using user email as org email initially
                organizationMobile: formData.phone, // Using user phone as org phone initially

                // Settings object
                settings: {
                    industry: formData.industry,
                    companySize: formData.companySize,
                    country: formData.country,
                    countryName: countries.find(c => c.value === formData.country)?.label,
                    state: formData.state,
                    stateName: states.find(s => s.value === formData.state)?.label,
                    timezone: formData.timezone,
                    currency: formData.currency,
                    marketingEmails: formData.marketingEmails
                }
            };

            const response = await api.post(SummaryApi.registerOrgWithAdmin.url, submitData);

            if (response.data) {
                // Store token and user data
                localStorage.setItem('ata', response.data.token);
                
                toast.success('Account created successfully!');

                // Navigate to dashboard or onboarding
                navigate('/dashboard'); // or '/onboarding' based on your flow
            }

        } catch (error) {
            console.error('Signup error:', error);

            if (error.response?.status === 409) {
                // Handle duplicate email/organization
                toast.error(error.response.data.message || 'An account with this email already exists');
            } else if (error.response?.status === 400) {
                // Handle validation errors
                toast.error(error.response.data.message || 'Please check your input and try again');
            } else if (error.response?.data?.message) {
                toast.error(error.response.data.message);
            } else {
                toast.error('Signup failed. Please try again.');
            }
        } finally {
            setIsLoading(false);
        }
    };


    // Google Signup
    const googleSignup = useGoogleLogin({
        onSuccess: async (tokenResponse) => {
            try {
                setIsLoading(true);

                // Get user info from Google
                const userInfoResponse = await axios.get('https://www.googleapis.com/oauth2/v3/userinfo', {
                    headers: {
                        Authorization: `Bearer ${tokenResponse.access_token}`,
                    },
                });

                const googleUserInfo = userInfoResponse.data;

                // Send ID token to backend
                const response = await api.post(SummaryApi.googleLogin.url, {
                    idToken: tokenResponse.access_token, // or use tokenResponse.id_token if available
                });

                if (response.data.token) {
                    // User exists and logged in successfully
                    localStorage.setItem('ata', response.data.token);
                    toast.success('Logged in successfully!');
                    navigate('/dashboard');
                } else {
                    // New user - pre-fill form and continue with registration
                    setFormData(prev => ({
                        ...prev,
                        email: googleUserInfo.email,
                        firstName: googleUserInfo.given_name || '',
                        lastName: googleUserInfo.family_name || ''
                    }));

                    toast.info('Please complete your organization details');
                    setCurrentStep(2);
                }

            } catch (error) {
                console.error('Google signup error:', error);

                if (error.response?.status === 404) {
                    // User not found - continue with registration
                    toast.info('Please complete your registration');
                } else {
                    toast.error('Google signup failed. Please try again.');
                }
            } finally {
                setIsLoading(false);
            }
        },
        onError: (error) => {
            console.error('Google OAuth error:', error);
            toast.error('Google signup error');
        },
        flow: 'implicit', // or 'auth-code' based on your setup
    });


    // Custom styles for react-select
    const selectStyles = {
        control: (base, state) => ({
            ...base,
            padding: '0.25rem',
            borderColor: finalValidation && errors[state.selectProps.name] ? '#fca5a5' : '#d1d5db',
            '&:hover': {
                borderColor: state.isFocused ? '#3b82f6' : '#9ca3af'
            }
        }),
        menu: (base) => ({
            ...base,
            zIndex: 9999
        })
    };

    return (
        <div className="min-h-screen relative overflow-hidden bg-gradient-to-br from-blue-50 via-green-50 to-yellow-50">
            {/* Background Pattern */}
            <div className="absolute inset-0 opacity-10">
                <div
                    className="absolute inset-0"
                    style={{
                        backgroundImage: `
              repeating-linear-gradient(45deg, transparent, transparent 35px, rgba(59, 130, 246, 0.1) 35px, rgba(59, 130, 246, 0.1) 70px),
              repeating-linear-gradient(-45deg, transparent, transparent 35px, rgba(239, 68, 68, 0.1) 35px, rgba(239, 68, 68, 0.1) 70px),
              repeating-linear-gradient(90deg, transparent, transparent 50px, rgba(34, 197, 94, 0.1) 50px, rgba(34, 197, 94, 0.1) 100px)
            `
                    }}
                />
                <div className="absolute top-20 left-20 w-24 h-24 bg-blue-500 opacity-10 rounded-lg transform rotate-45"></div>
                <div className="absolute top-40 right-40 w-32 h-32 bg-red-500 opacity-10 rounded-lg transform rotate-12"></div>
                <div className="absolute bottom-20 left-1/3 w-28 h-28 bg-green-500 opacity-10 rounded-lg transform -rotate-12"></div>
                <div className="absolute bottom-40 right-20 w-20 h-20 bg-yellow-500 opacity-10 rounded-lg transform rotate-45"></div>
            </div>

            <div className="relative flex items-center justify-center min-h-screen p-4">
                <div className="bg-white rounded-2xl shadow-2xl w-full max-w-2xl p-8 backdrop-blur-sm my-8">
                    {/* Header */}
                    <div className="text-center mb-6">
                        <div className="flex justify-center mb-4">
                            <img src={Logo2} alt="Cuso Business Logo" className="w-auto h-20" />
                        </div>
                        <h1 className="text-3xl font-bold text-red-600 mb-2">Create your account</h1>
                        <p className="text-gray-600">Start your 7-day free trial</p>

                        {/* Progress Steps */}
                        <div className="mt-6 flex items-center justify-center space-x-2">
                            {[1, 2, 3].map((step) => (
                                <React.Fragment key={step}>
                                    <div className={`
                    w-8 h-8 rounded-full flex items-center justify-center text-sm font-medium
                    ${currentStep >= step
                                            ? 'bg-blue-600 text-white'
                                            : 'bg-gray-200 text-gray-500'}
                  `}>
                                        {step}
                                    </div>
                                    {step < 3 && (
                                        <div className={`w-16 h-1 ${currentStep > step ? 'bg-blue-600' : 'bg-gray-200'}`} />
                                    )}
                                </React.Fragment>
                            ))}
                        </div>
                        <div className="mt-2 text-sm text-gray-600">
                            {currentStep === 1 && "Personal Information"}
                            {currentStep === 2 && "Organization Details"}
                            {currentStep === 3 && "Location & Preferences"}
                        </div>
                    </div>

                    {/* Form */}
                    <form onSubmit={handleSubmit}>
                        {/* Step 1: Personal Information */}
                        {currentStep === 1 && (
                            <div className="space-y-4">
                                <div className="grid grid-cols-2 gap-4">
                                    <div>
                                        <label className="block text-sm font-medium text-gray-700 mb-2">First Name</label>
                                        <div className="relative">
                                            <div className="absolute inset-y-0 left-0 pl-3 flex items-center pointer-events-none">
                                                <User className="h-5 w-5 text-gray-400" />
                                            </div>
                                            <input
                                                type="text"
                                                name="firstName"
                                                value={formData.firstName}
                                                onChange={handleInputChange}
                                                className={`
                          w-full pl-10 pr-3 py-3 border rounded-lg
                          ${errors.firstName ? 'border-red-300' : 'border-gray-300'}
                          focus:outline-none focus:ring-2 focus:ring-blue-500 focus:border-blue-500
                        `}
                                                placeholder="John"
                                            />
                                        </div>
                                        {errors.firstName && <p className="mt-1 text-sm text-red-600">{errors.firstName}</p>}
                                    </div>

                                    <div>
                                        <label className="block text-sm font-medium text-gray-700 mb-2">Last Name</label>
                                        <div className="relative">
                                            <div className="absolute inset-y-0 left-0 pl-3 flex items-center pointer-events-none">
                                                <User className="h-5 w-5 text-gray-400" />
                                            </div>
                                            <input
                                                type="text"
                                                name="lastName"
                                                value={formData.lastName}
                                                onChange={handleInputChange}
                                                className={`
                          w-full pl-10 pr-3 py-3 border rounded-lg
                          ${errors.lastName ? 'border-red-300' : 'border-gray-300'}
                          focus:outline-none focus:ring-2 focus:ring-blue-500 focus:border-blue-500
                        `}
                                                placeholder="Doe"
                                            />
                                        </div>
                                        {errors.lastName && <p className="mt-1 text-sm text-red-600">{errors.lastName}</p>}
                                    </div>
                                </div>

                                <div>
                                    <label className="block text-sm font-medium text-gray-700 mb-2">Email</label>
                                    <div className="relative">
                                        <div className="absolute inset-y-0 left-0 pl-3 flex items-center pointer-events-none">
                                            <Mail className="h-5 w-5 text-gray-400" />
                                        </div>
                                        <input
                                            type="email"
                                            name="email"
                                            value={formData.email}
                                            onChange={handleInputChange}
                                            className={`
                        w-full pl-10 pr-3 py-3 border rounded-lg
                        ${errors.email ? 'border-red-300' : 'border-gray-300'}
                        focus:outline-none focus:ring-2 focus:ring-blue-500 focus:border-blue-500
                      `}
                                            placeholder="john@example.com"
                                        />
                                    </div>
                                    {errors.email && <p className="mt-1 text-sm text-red-600">{errors.email}</p>}
                                </div>

                                <div>
                                    <label className="block text-sm font-medium text-gray-700 mb-2">Phone</label>
                                    <PhoneInput
                                        country={'us'}
                                        value={formData.phone}
                                        onChange={handlePhoneChange}
                                        inputProps={{
                                            name: 'phone',
                                            required: true,
                                        }}
                                        containerStyle={{
                                            width: '100%',
                                        }}
                                        inputStyle={{
                                            width: '100%',
                                            height: '48px',
                                            fontSize: '16px',
                                            paddingLeft: '48px',
                                            borderColor: errors.phone ? '#fca5a5' : '#d1d5db',
                                            borderRadius: '0.5rem',
                                        }}
                                        buttonStyle={{
                                            borderColor: errors.phone ? '#fca5a5' : '#d1d5db',
                                            borderRadius: '0.5rem 0 0 0.5rem',
                                            backgroundColor: '#f9fafb',
                                        }}
                                        dropdownStyle={{
                                            width: 'max-content',
                                            borderRadius: '0.5rem',
                                        }}
                                        searchStyle={{
                                            padding: '10px',
                                            width: '100%',
                                        }}
                                        enableSearch={true}
                                        searchPlaceholder="Search country"
                                        specialLabel=""
                                        autoFormat={true}
                                    />
                                    {errors.phone && <p className="mt-1 text-sm text-red-600">{errors.phone}</p>}
                                </div>

                                <div>
                                    <label className="block text-sm font-medium text-gray-700 mb-2">Password</label>
                                    <div className="relative">
                                        <div className="absolute inset-y-0 left-0 pl-3 flex items-center pointer-events-none">
                                            <Lock className="h-5 w-5 text-gray-400" />
                                        </div>
                                        <input
                                            type={showPassword ? 'text' : 'password'}
                                            name="password"
                                            value={formData.password}
                                            onChange={handleInputChange}
                                            className={`
                        w-full pl-10 pr-12 py-3 border rounded-lg
                        ${errors.password ? 'border-red-300' : 'border-gray-300'}
                        focus:outline-none focus:ring-2 focus:ring-blue-500 focus:border-blue-500
                      `}
                                            placeholder="••••••••"
                                        />
                                        <button
                                            type="button"
                                            onClick={() => setShowPassword(!showPassword)}
                                            className="absolute inset-y-0 right-0 pr-3 flex items-center"
                                        >
                                            {showPassword ? <EyeOff className="h-5 w-5 text-gray-400" /> : <Eye className="h-5 w-5 text-gray-400" />}
                                        </button>
                                    </div>
                                    {errors.password && <p className="mt-1 text-sm text-red-600">{errors.password}</p>}
                                </div>

                                <div>
                                    <label className="block text-sm font-medium text-gray-700 mb-2">Confirm Password</label>
                                    <div className="relative">
                                        <div className="absolute inset-y-0 left-0 pl-3 flex items-center pointer-events-none">
                                            <Lock className="h-5 w-5 text-gray-400" />
                                        </div>
                                        <input
                                            type={showConfirmPassword ? 'text' : 'password'}
                                            name="confirmPassword"
                                            value={formData.confirmPassword}
                                            onChange={handleInputChange}
                                            className={`
                        w-full pl-10 pr-12 py-3 border rounded-lg
                        ${errors.confirmPassword ? 'border-red-300' : 'border-gray-300'}
                        focus:outline-none focus:ring-2 focus:ring-blue-500 focus:border-blue-500
                      `}
                                            placeholder="••••••••"
                                        />
                                        <button
                                            type="button"
                                            onClick={() => setShowConfirmPassword(!showConfirmPassword)}
                                            className="absolute inset-y-0 right-0 pr-3 flex items-center"
                                        >
                                            {showConfirmPassword ? <EyeOff className="h-5 w-5 text-gray-400" /> : <Eye className="h-5 w-5 text-gray-400" />}
                                        </button>
                                    </div>
                                    {errors.confirmPassword && <p className="mt-1 text-sm text-red-600">{errors.confirmPassword}</p>}
                                </div>

                                {/* Google Signup Option */}
                                <div className="relative">
                                    <div className="absolute inset-0 flex items-center">
                                        <div className="w-full border-t border-gray-300"></div>
                                    </div>
                                    <div className="relative flex justify-center text-sm">
                                        <span className="px-2 bg-white text-gray-500">Or</span>
                                    </div>
                                </div>

                                <button
                                    type="button"
                                    onClick={() => googleSignup()}
                                    className="w-full flex items-center justify-center gap-3 border border-gray-300 rounded-lg py-3 px-4 hover:bg-gray-50 transition-colors"
                                >
                                    <svg className="h-5 w-5" viewBox="0 0 24 24">
                                        <path d="M22.56 12.25c0-.78-.07-1.53-.2-2.25H12v4.26h5.92c-.26 1.37-1.04 2.53-2.21 3.31v2.77h3.57c2.08-1.92 3.28-4.74 3.28-8.09z" fill="#4285F4" />
                                        <path d="M12 23c2.97 0 5.46-.98 7.28-2.66l-3.57-2.77c-.98.66-2.23 1.06-3.71 1.06-2.86 0-5.29-1.93-6.16-4.53H2.18v2.84C3.99 20.53 7.7 23 12 23z" fill="#34A853" />
                                        <path d="M5.84 14.09c-.22-.66-.35-1.36-.35-2.09s.13-1.43.35-2.09V7.07H2.18C1.43 8.55 1 10.22 1 12s.43 3.45 1.18 4.93l2.85-2.22.81-.62z" fill="#FBBC05" />
                                        <path d="M12 5.38c1.62 0 3.06.56 4.21 1.64l3.15-3.15C17.45 2.09 14.97 1 12 1 7.7 1 3.99 3.47 2.18 7.07l3.66 2.84c.87-2.6 3.3-4.53 6.16-4.53z" fill="#EA4335" />
                                    </svg>
                                    <span className="font-medium text-gray-700">Sign up with Google</span>
                                </button>
                            </div>
                        )}

                        {/* Step 2: Organization Details */}
                        {currentStep === 2 && (
                            <div className="space-y-4">
                                <div>
                                    <label className="block text-sm font-medium text-gray-700 mb-2">Organization Name</label>
                                    <div className="relative">
                                        <div className="absolute inset-y-0 left-0 pl-3 flex items-center pointer-events-none">
                                            <Building2 className="h-5 w-5 text-gray-400" />
                                        </div>
                                        <input
                                            type="text"
                                            name="organizationName"
                                            value={formData.organizationName}
                                            onChange={handleInputChange}
                                            className={`
                        w-full pl-10 pr-3 py-3 border rounded-lg
                        ${errors.organizationName ? 'border-red-300' : 'border-gray-300'}
                        focus:outline-none focus:ring-2 focus:ring-blue-500 focus:border-blue-500
                      `}
                                            placeholder="Acme Corporation"
                                        />
                                    </div>
                                    {errors.organizationName && <p className="mt-1 text-sm text-red-600">{errors.organizationName}</p>}
                                </div>

                                <div>
                                    <label className="block text-sm font-medium text-gray-700 mb-2">Industry</label>
                                    <select
                                        name="industry"
                                        value={formData.industry}
                                        onChange={handleInputChange}
                                        className={`
                      w-full px-3 py-3 border rounded-lg appearance-none
                      ${errors.industry ? 'border-red-300' : 'border-gray-300'}
                      focus:outline-none focus:ring-2 focus:ring-blue-500 focus:border-blue-500
                    `}
                                    >
                                        <option value="">Select industry</option>
                                        {industries.map(industry => (
                                            <option key={industry} value={industry}>{industry}</option>
                                        ))}
                                    </select>
                                    {errors.industry && <p className="mt-1 text-sm text-red-600">{errors.industry}</p>}
                                </div>

                                <div>
                                    <label className="block text-sm font-medium text-gray-700 mb-2">Company Size</label>
                                    <select
                                        name="companySize"
                                        value={formData.companySize}
                                        onChange={handleInputChange}
                                        className={`
                      w-full px-3 py-3 border rounded-lg appearance-none
                      ${errors.companySize ? 'border-red-300' : 'border-gray-300'}
                      focus:outline-none focus:ring-2 focus:ring-blue-500 focus:border-blue-500
                    `}
                                    >
                                        <option value="">Select company size</option>
                                        {companySizes.map(size => (
                                            <option key={size} value={size}>{size}</option>
                                        ))}
                                    </select>
                                    {errors.companySize && <p className="mt-1 text-sm text-red-600">{errors.companySize}</p>}
                                </div>
                            </div>
                        )}

                        {/* Step 3: Location & Preferences */}
                        {currentStep === 3 && (
                            <div className="space-y-4">
                                <div>
                                    <label className="block text-sm font-medium text-gray-700 mb-2">
                                        Country <span className="text-red-500">*</span>
                                    </label>
                                    <Select
                                        name="country"
                                        value={countries.find(c => c.value === formData.country)}
                                        onChange={(option) => handleSelectChange('country', option)}
                                        options={countries}
                                        placeholder="Select country"
                                        isClearable
                                        isSearchable
                                        styles={selectStyles}
                                        className="react-select-container"
                                        classNamePrefix="react-select"
                                    />
                                    {finalValidation && errors.country && <p className="mt-1 text-sm text-red-600">{errors.country}</p>}
                                </div>

                                {/* State field - only show if country has states */}
                                {formData.country && states.length > 0 && (
                                    <div>
                                        <label className="block text-sm font-medium text-gray-700 mb-2">State/Province</label>
                                        <Select
                                            name="state"
                                            value={states.find(s => s.value === formData.state)}
                                            onChange={(option) => handleSelectChange('state', option)}
                                            options={states}
                                            placeholder="Select state"
                                            isClearable
                                            isSearchable
                                            styles={selectStyles}
                                            className="react-select-container"
                                            classNamePrefix="react-select"
                                        />
                                    </div>
                                )}

                                <div>
                                    <label className="block text-sm font-medium text-gray-700 mb-2">
                                        Timezone <span className="text-red-500">*</span>
                                    </label>
                                    <Select
                                        name="timezone"
                                        value={timezones.find(tz => tz.value === formData.timezone)}
                                        onChange={(option) => handleSelectChange('timezone', option)}
                                        options={timezones}
                                        placeholder="Select timezone"
                                        isClearable
                                        isSearchable
                                        styles={selectStyles}
                                        className="react-select-container"
                                        classNamePrefix="react-select"
                                    />
                                    {finalValidation && errors.timezone && <p className="mt-1 text-sm text-red-600">{errors.timezone}</p>}
                                </div>

                                {/* Agreement Checkboxes */}
                                <div className="space-y-3 pt-4">
                                    <div className="flex items-start">
                                        <input
                                            type="checkbox"
                                            id="terms"
                                            name="termsAccepted"
                                            checked={formData.termsAccepted}
                                            onChange={handleInputChange}
                                            className="h-4 w-4 mt-0.5 text-blue-600 border-gray-300 rounded focus:ring-blue-500"
                                        />
                                        <label htmlFor="terms" className="ml-2 text-sm text-gray-700">
                                            I agree to the{' '}
                                            <a href="/terms" className="text-blue-600 hover:text-blue-500">Terms of Service</a>
                                            {' '}and{' '}
                                            <a href="/privacy" className="text-blue-600 hover:text-blue-500">Privacy Policy</a>
                                            <span className="text-red-500"> *</span>
                                        </label>
                                    </div>
                                    {finalValidation && errors.termsAccepted && <p className="text-sm text-red-600">{errors.termsAccepted}</p>}

                                    <div className="flex items-start">
                                        <input
                                            type="checkbox"
                                            id="marketing"
                                            name="marketingEmails"
                                            checked={formData.marketingEmails}
                                            onChange={handleInputChange}
                                            className="h-4 w-4 mt-0.5 text-blue-600 border-gray-300 rounded focus:ring-blue-500"
                                        />
                                        <label htmlFor="marketing" className="ml-2 text-sm text-gray-700">
                                            I'd like to receive marketing emails about product updates and special offers
                                        </label>
                                    </div>
                                </div>
                            </div>
                        )}

                        {/* Navigation Buttons */}
                        <div className="mt-8 flex justify-between">
                            {currentStep > 1 && (
                                <button
                                    type="button"
                                    onClick={handlePrevStep}
                                    className="px-6 py-3 border border-gray-300 rounded-lg text-gray-700 hover:bg-gray-50 transition-colors"
                                >
                                    Previous
                                </button>
                            )}

                            {currentStep < 3 ? (
                                <button
                                    type="button"
                                    onClick={handleNextStep}
                                    className="ml-auto px-6 py-3 bg-blue-600 text-white rounded-lg hover:bg-blue-700 transition-colors"
                                >
                                    Next
                                </button>
                            ) : (
                                <button
                                    type="submit"
                                    disabled={isLoading}
                                    className="ml-auto px-6 py-3 bg-gradient-to-r from-blue-600 to-blue-700 text-white rounded-lg hover:from-blue-700 hover:to-blue-800 disabled:opacity-50 flex items-center transition-all"
                                >
                                    {isLoading ? (
                                        <>
                                            <Loader2 className="animate-spin -ml-1 mr-2 h-5 w-5" />
                                            Creating account...
                                        </>
                                    ) : (
                                        'Create Account'
                                    )}
                                </button>
                            )}
                        </div>
                    </form>

                    {/* Login Link */}
                    <div className="mt-6 text-center text-sm">
                        <span className="text-gray-600">Already have an account? </span>
                        <a href="/login" className="text-blue-600 hover:text-blue-500 font-medium">
                            Sign in
                        </a>
                    </div>
                </div>
            </div>

            {/* Custom CSS for react-phone-input-2 */}
            <style global={true}>{`
        .react-tel-input .form-control {
          width: 100% !important;
          height: 48px !important;
          font-size: 16px !important;
          border-radius: 0.5rem !important;
          border: 1px solid #d1d5db !important;
          padding-left: 48px !important;
          transition: all 0.2s !important;
        }

        .react-tel-input .form-control:focus {
          outline: none !important;
          border-color: #3b82f6 !important;
          box-shadow: 0 0 0 3px rgba(59, 130, 246, 0.1) !important;
        }

        .react-tel-input .flag-dropdown {
          border-radius: 0.5rem 0 0 0.5rem !important;
          border: 1px solid #d1d5db !important;
          border-right: none !important;
          background-color: #f9fafb !important;
          transition: all 0.2s !important;
        }

        .react-tel-input .flag-dropdown:hover {
          background-color: #f3f4f6 !important;
        }

        .react-tel-input .selected-flag {
          padding: 0 0 0 8px !important;
          height: 100% !important;
          display: flex !important;
          align-items: center !important;
        }

        .react-tel-input .country-list {
          border-radius: 0.5rem !important;
          box-shadow: 0 10px 15px -3px rgba(0, 0, 0, 0.1), 0 4px 6px -2px rgba(0, 0, 0, 0.05) !important;
          margin-top: 4px !important;
        }

        .react-tel-input .country-list .search {
          padding: 10px !important;
          margin: 0 !important;
          border-radius: 0.25rem !important;
          border: 1px solid #d1d5db !important;
        }

        .react-tel-input .country-list .search:focus {
          outline: none !important;
                    border-color: #3b82f6 !important;
        }

        .react-tel-input .country-list .country {
          padding: 8px 10px !important;
          transition: all 0.2s !important;
        }

        .react-tel-input .country-list .country:hover {
          background-color: #f3f4f6 !important;
        }

        .react-tel-input .country-list .country.highlight {
          background-color: #3b82f6 !important;
        }

        .react-tel-input .flag-dropdown.open {
          border-color: #3b82f6 !important;
        }

        .react-tel-input .flag-dropdown.open ~ .form-control {
          border-color: #3b82f6 !important;
        }

        /* Error state styles */
        .react-tel-input .form-control.error {
          border-color: #fca5a5 !important;
        }

        .react-tel-input .flag-dropdown.error {
          border-color: #fca5a5 !important;
        }

        /* Responsive styles */
        @media (max-width: 640px) {
          .react-tel-input .form-control {
            font-size: 16px !important;
          }
        }
      `}</style>
        </div>
    );
};

export default SignUp;
